import type { App } from 'vue'
import * as components from './registry'

export type { DgThumbRailItem } from './agent/DgThumbRail.vue'
export type { DgTableHeader, DgTableSortItem } from './data/DgTable.vue'
export type { DgTimelineItem } from './data/DgTimeline.vue'
export type { DgMenuItem } from './navigation/DgMenu.vue'
export type { DgSidebarNavItem, DgSidebarNavSection } from './navigation/DgSidebarNav.vue'
export * from './registry'

type Registry = typeof components

declare module 'vue' {
  interface GlobalComponents extends Registry {}
}

export const registerComponents = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
